<div class="st-page">
  <div class="st-page-head">
    <div class="fsh-head-left">
      <button type="button" class="sfr-icon-btn" (click)="goBack()"><i class="ri-arrow-left-line"></i></button>
      <div>
        <h1 class="st-title">{{ className }}</h1>
        <p class="st-subtitle">{{ studentName }}</p>
      </div>
    </div>
  </div>

  <div class="fsh-stat-card st-card">
    <ng-container *ngIf="!fetchingStudentData; else statSkeleton">
      <div class="fsh-stat-row">
        <div>
          <div class="fsh-stat-label">{{ 'totalAmount' | translate }}</div>
          <div class="fsh-stat-value">{{ formatAmount(totalAmount) }}</div>
        </div>
        <div>
          <div class="fsh-stat-label">{{ 'unpaid' | translate }}</div>
          <div class="fsh-stat-value">{{ formatAmount(pendingAmount) }}</div>
        </div>
      </div>
      <div class="fsh-progress-track">
        <div class="fsh-progress-fill" [style.width.%]="feesPercentagePending"></div>
      </div>
    </ng-container>
    <ng-template #statSkeleton>
      <div class="fsh-stat-skeleton"></div>
    </ng-template>
  </div>

  <div class="st-tv-list" *ngIf="fetchingStudentData">
    <div class="st-card fsh-skeleton-card" *ngFor="let s of [1,2,3,4]"></div>
  </div>

  <ng-container *ngIf="!fetchingStudentData">
    <div class="fsh-fee-list" *ngIf="feesInfo.length">
      <div class="st-card fsh-fee-card" *ngFor="let f of feesInfo">
        <div class="fsh-fee-head">
          <div class="fsh-fee-name">{{ f.TermName || f.typename }}</div>
        </div>
        <div class="fsh-fee-due">{{ 'due' | translate }} {{ formatDate(f.DueDate) }}</div>
        <div class="fsh-fee-breakdown">
          <div class="fsh-fee-line" *ngFor="let d of f.studentFeeDetail">
            <span>{{ d.label }}</span><span>{{ formatAmount(d.value) }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="st-empty-state" *ngIf="!feesInfo.length">
      <i class="ri-file-list-3-line"></i> {{ 'noFeesData' | translate }}
    </div>
  </ng-container>
</div>
